// @flow
import { createPath } from '@foxford/foxford-utils'

import { history } from 'services/history'

/**
 * Проверяет является ли url внешним
 */
export const isExternalUrl = (url: string): boolean => {
  return /^((http|https):\/\/)/.test(url)
}

/**
 * Возвращает url внешний или внутренний по параметрам
 * @param {string} url ссылка
 * @param {boolean} redirectBack добавить параметр редиректа или нет
 */
export const getExternalInternalUrl = (
  url: string,
  params: { [string]: string } = {},
  redirectBack: boolean = false
): string => {
  const queryParams = {
    ...params,
  }

  if (redirectBack) {
    queryParams.redirect_url = window.location.origin
  }

  let link = url ? createPath(url, queryParams) : url

  if (process.env.REACT_APP_EXTERNAL === 'true' && !isExternalUrl(url) && link) {
    link = `https://foxford.ru/${link.replace(/^\//g, '')}`
  }

  return link
}

/**
 * Get file extension from src
 *
 * @param {'string'} src
 * @returns {(string | void)} file extension
 */
export const getFileExtension = (src: string): string | void => {
  if (typeof src !== 'string') {
    throw new TypeError('Provided src is not a string')
  }

  if (!src.includes('.')) {
    return undefined
  }

  return src.split('.').pop()
}

export const ejectQueryParameter = (parameter: string, removeAfterEject?: boolean = false): string | void => {
  const { search } = history.location

  if (search === '') {
    return undefined
  }

  const name = parameter.replace(/\\/, '\\')
  const regex = new RegExp(`^(.*?)&?${name}=([^&]*)&?(.*)$`)
  let value: string | void

  const newQuery = search.replace(regex, (_, start, queryValue, end) => {
    value = queryValue

    if (start === '?') {
      return end === '' ? '' : `${start}${end}`
    }

    return end === '' ? start : `${start}&${end}`
  })

  if (value !== undefined && removeAfterEject) {
    history.replace({ search: newQuery })
  }

  return value
}
